import { ChangeEvent, KeyboardEvent } from 'react'
import { Checkbox, TextField } from '@nexds/web'

import { CheckboxWrapper, Container, Divider, HeaderButton, Label } from './FuelSelectablePriceField.styles'

interface FuelSelectablePriceFieldProps {
  id: string
  label: string
  checked: boolean
  onCheckedChange: (nextChecked: boolean) => void
  value: string
  onValueChange: (nextValue: string) => void
  placeholder: string
  mask?: string
  error?: boolean
  helpMessage?: string
  helpGutter?: boolean
  disabled?: boolean
  onInputFocus?: () => void
  onInputBlur?: () => void
}

function FuelSelectablePriceField(props: FuelSelectablePriceFieldProps) {
  const {
    id,
    label,
    checked,
    onCheckedChange,
    value,
    onValueChange,
    placeholder,
    mask,
    error,
    helpMessage,
    helpGutter,
    disabled,
    onInputFocus,
    onInputBlur
  } = props

  const handleToggle = () => {
    if (disabled) return
    onCheckedChange(!checked)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (disabled) return
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onCheckedChange(!checked)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onValueChange(event.target.value)
  }

  return (
    <Container>
      <HeaderButton
        type="button"
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        aria-expanded={checked}
        aria-controls={`${id}-price-field`}
      >
        <Label>{label}</Label>
        <CheckboxWrapper
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
          }}
        >
          <Checkbox
            checked={checked}
            onChange={(event) => {
              onCheckedChange(event.target.checked)
            }}
            disabled={disabled}
          />
        </CheckboxWrapper>
      </HeaderButton>

      {checked && (
        <>
          <Divider />
          <TextField
            id={id}
            size="md"
            placeholder={placeholder}
            mask={mask}
            inputMode="numeric"
            error={error}
            helpMessage={helpMessage}
            helpGutter={helpGutter}
            value={value}
            onChange={handleChange}
            onFocus={onInputFocus}
            onBlur={onInputBlur}
            disabled={disabled}
          />
        </>
      )}
    </Container>
  )
}

export { FuelSelectablePriceField }
